/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptQuoteResource
 */
export interface AcceptQuoteResource {
    /**
     * 
     * @type {string}
     * @memberof AcceptQuoteResource
     */
    projectId: string;
}

/**
 * Check if a given object implements the AcceptQuoteResource interface.
 */
export function instanceOfAcceptQuoteResource(value: object): value is AcceptQuoteResource {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    return true;
}

export function AcceptQuoteResourceFromJSON(json: any): AcceptQuoteResource {
    return AcceptQuoteResourceFromJSONTyped(json, false);
}

export function AcceptQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptQuoteResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
    };
}

export function AcceptQuoteResourceToJSON(value?: AcceptQuoteResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectId': value['projectId'],
    };
}

